import { render, staticRenderFns } from "./CalendarCarousel.vue?vue&type=template&id=40629472&scoped=true&"
import script from "./CalendarCarousel.vue?vue&type=script&lang=js&"
export * from "./CalendarCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CalendarCarousel.vue?vue&type=style&index=0&id=40629472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40629472",
  null
  
)

export default component.exports